import TransfersPage from "components/pages/TransfersPage";

export default function CaptureLoanTransferTransfer(props) {
    return <TransfersPage />
}